import React from 'react';
import {Upload} from 'antd';
import toast from "react-hot-toast";

const UploadComponent = ({image, setImage, name = '이름을 설정해주세요.'}) => {

    const onChange = ({file: newFile}) => {
        setImage(newFile);
    };

    const onRemove = () => {
        setImage(null);
    };

    const onPreview = async (file) => {
        let src = file.url;
        if (!src) {
            src = await new Promise((resolve) => {
                const reader = new FileReader();
                reader.readAsDataURL(file.originFileObj);
                reader.onload = () => resolve(reader.result);
            });
        }
        const image = new Image();
        image.src = src;
        const imgWindow = window.open(src);
        imgWindow?.document.write(image.outerHTML);
    };

    return (
        <div>
            <Upload
                action={process.env.REACT_APP_URL + 'upload/probability/images'}
                listType="picture-card"
                accept="image/*"
                fileList={image?.name ? [image] : []}
                beforeUpload={(file) => {
                    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
                    if (!isJpgOrPng) {
                        toast.error('jpg, png 파일만 업로드 가능합니다.');
                    }
                    return isJpgOrPng;
                }}
                onChange={onChange}
                onRemove={onRemove}
                onPreview={onPreview}
                withCredentials={true}
                maxCount={1}
                showUploadList={true}
                progress={{
                    showInfo: true,
                    strokeColor: {
                        from: 'rgba(77,230,105,0.85)',
                        to: '#1677ff',
                    },
                    size: 3,
                }}
            >
                {name}
            </Upload>
        </div>
    );
};

export default UploadComponent;